// extracted by mini-css-extract-plugin
export var videowrapper = "slider_item-module--videowrapper--61b17";